import { InjectionToken } from '@angular/core';

export const LIST_ID = new InjectionToken<string>('app.context.listId');
